import React, { useEffect, useState } from 'react';
import styles from './PopupAddIngredient.module.css';
import { bodyScrollOverflowAuto, generateRandomString } from '../../helper';
import CloseBtn from '../../elemets/CloseBtn/CloseBtn';
import { BasketSvg } from '../../SVGComponents/SVGComponents';
import { useDispatch, useSelector } from 'react-redux';
import {
  addDataToActiveingredientRedux,
  onChangeIngredientAndBasketRedux,
} from '../../store/slices/menuSlice';
import NutritionalTableDay from '../NutritionalTableDay/NutritionalTableDay';
import NutritionalValue from '../NutritionalValue/NutritionalValue';
import { getObjectIngredient } from '../../helperProject';
import Checkbox from '../../elemets/Checkbox/Checkbox';

export default function PopupAddIngredient({
  mealName,
  menuIndex,
  indexIngredientGropIndex,
  indexIngredient,
  handleClick,
  ingredientsArray,
}) {
  // console.log(
  //   mealName,
  //   menuIndex,
  //   indexIngredientGropIndex,
  //   indexIngredient,
  //   handleClick,
  //   ingredientsArray,
  // );

  const dispatch = useDispatch();

  const menuMealTwoServings = useSelector((state) => state.menu.menuDay[mealName].twoServings);
  const activeIngredient = useSelector(
    (state) =>
      state.menu.menuDay[mealName].menuText[menuIndex].ingredients[indexIngredientGropIndex]
        .ingredientsItems[indexIngredient],
  );

  const [searchIngredientsArray, setSearchIngredientsArray] = useState(ingredientsArray);
  const [search, setSearch] = useState('');

  // console.log('mealName === ', mealName);
  // console.log('menuIndex === ', menuIndex);
  // console.log('indexIngredientGropIndex === ', indexIngredientGropIndex);
  // console.log('indexIngredient === ', indexIngredient);

  useEffect(() => {
    return () => {
      bodyScrollOverflowAuto();
    };
  }, []);

  const closePopup = (value) => {
    bodyScrollOverflowAuto();
    handleClick(value);
  };

  // Пошук інгридієнта
  const searchIngredients = (inputValue) => {
    setSearch(inputValue);

    const result = [];

    ingredientsArray.forEach((item) => {
      if (item.textIngredientDefault.toLowerCase().search(inputValue.toLowerCase()) != -1) {
        result.push(item);
      }
    });
    setSearchIngredientsArray(result);
  };

  const addDataToActiveingredient = (
    data,
    mealName,
    menuIndex,
    indexIngredientGropIndex,
    indexIngredient,
    ingredientsArray,
  ) => {
    dispatch(
      addDataToActiveingredientRedux({
        data: { ...data, id: generateRandomString() },
        mealName,
        menuIndex,
        indexIngredientGropIndex,
        indexIngredient,
        ingredientsArray,
      }),
    );
  };
  const renderIngredients = (ingredientsArray) => {
    return ingredientsArray.map((item) => {
      return (
        <div
          onClick={() =>
            addDataToActiveingredient(
              item,
              mealName,
              menuIndex,
              indexIngredientGropIndex,
              indexIngredient,
              ingredientsArray,
            )
          }
          key={item.id}
          className={'mb_5 pt_3 pb_3 hover activeClick'}>
          {item.textIngredientDefault}{' '}
          <small className={'op_05'}>
            ({item.unitIngredient}) ({item.unitBasket})
          </small>
        </div>
      );
    });
  };

  // Округляє число
  const roundinValue = (onChangeIngredientValue, roundinIngredientValue) => {
    // Округлення до найближчого кратного  5
    function roundToNearestFive(num) {
      return Math.round(num / 5) * 5;
    }
    // Округляє лише десяті до найближчого кратного 0.5
    function roundToNearestHalf(num) {
      return Math.round(num * 2) / 2;
    }
    // Округлення до найближчого кратного  5
    if (roundinIngredientValue === 5) {
      return roundToNearestFive(onChangeIngredientValue);
    }
    // Округляє до найближчого кратного 0.5
    if (roundinIngredientValue === 0.5) {
      return roundToNearestHalf(onChangeIngredientValue);
    }
    // округлює вниз (до меншого цілого)
    if (roundinIngredientValue === 'floor') {
      return Math.floor(onChangeIngredientValue);
    }
    // округлює вгору (до більшого цілого)
    if (roundinIngredientValue === 'ceil') {
      return Math.ceil(onChangeIngredientValue);
    }
    // округлює до десятків (0.2, 0.4, 0.6 .....)
    if (roundinIngredientValue === 'toFixed') {
      return Number(Number(onChangeIngredientValue).toFixed(1));
    }

    // округлює до найближчого цілого
    return Math.round(onChangeIngredientValue);
  };

  const getBasketValue = (currentActiveIngredient) => {
    let value = '';
    if (
      currentActiveIngredient.onChangeIngredientValue &&
      currentActiveIngredient.valueCalculateForBasket
    ) {
      value =
        Number(currentActiveIngredient.onChangeIngredientValue) *
        Number(currentActiveIngredient.valueCalculateForBasket);
    }

    return value != ''
      ? roundinValue(value, currentActiveIngredient.roundinProductBasketValue)
      : '';
  };

  const getEnergyValue = (energy, currentActiveIngredient) => {
    // console.log(currentActiveIngredient);

    if (menuMealTwoServings) {
      return (
        (currentActiveIngredient.onChangeIngredientValue *
          Number(currentActiveIngredient.valueCalculateForIngredient) *
          currentActiveIngredient[energy]) /
        Number(currentActiveIngredient.valueIngredientDefault) /
        2
      );
    }

    return (
      (Number(currentActiveIngredient.onChangeIngredientValue) *
        Number(currentActiveIngredient.valueCalculateForIngredient) *
        Number(currentActiveIngredient[energy])) /
      Number(currentActiveIngredient.valueIngredientDefault)
    );
  };
  // Додає інгридієнт
  const addValue = (
    whatToDo,
    activeIngredient,
    mealName,
    menuIndex,
    indexIngredientGropIndex,
    indexIngredient,
    targetValue,
  ) => {
    const currentActiveIngredient = {
      ...activeIngredient,
      onChangeIngredientValue: Number(activeIngredient.onChangeIngredientValue),
    };
    // const onChangeIngredientValue = Number(currentActiveIngredient.onChangeIngredientValue);

    // console.log('...activeIngredient === ', activeIngredient);
    // console.log('currentActiveIngredient === ', currentActiveIngredient);
    // console.log('onChangeIngredientValue === ', onChangeIngredientValue);

    if (whatToDo === 'plus') {
      const newValue = Number(currentActiveIngredient.onChangeIngredientValue) + 1;
      currentActiveIngredient.onChangeIngredientValue = newValue;
    }
    if (whatToDo === 'minus' && currentActiveIngredient.onChangeIngredientValue > 0) {
      const newValue = Number(currentActiveIngredient.onChangeIngredientValue) - 1;
      currentActiveIngredient.onChangeIngredientValue = newValue;
    }
    if (
      whatToDo === 'targetValue' &&
      Number(currentActiveIngredient.onChangeIngredientValue) >= 0
    ) {
      currentActiveIngredient.onChangeIngredientValue = targetValue;
    }
    //
    currentActiveIngredient.text =
      currentActiveIngredient.textIngredientDefault +
      ' ' +
      currentActiveIngredient.onChangeIngredientValue +
      ' ' +
      currentActiveIngredient.unitIngredient;
    //
    currentActiveIngredient.valueBasket = getBasketValue(currentActiveIngredient);
    //
    currentActiveIngredient.textBasketProduct =
      currentActiveIngredient.textBasketProductNameDefault +
      ' ' +
      currentActiveIngredient.valueBasket +
      ' ' +
      currentActiveIngredient.unitBasket;
    //
    currentActiveIngredient.сaloriesIngredient = getEnergyValue(
      'сaloriesProduct',
      currentActiveIngredient,
    );
    currentActiveIngredient.proteinIngredient = getEnergyValue(
      'proteinProduct',
      currentActiveIngredient,
    );
    currentActiveIngredient.fatsIngredient = getEnergyValue('fatsProduct', currentActiveIngredient);
    currentActiveIngredient.carbohydratesIngredient = getEnergyValue(
      'carbohydratesProduct',
      currentActiveIngredient,
    );

    dispatch(
      addDataToActiveingredientRedux({
        data: currentActiveIngredient,
        mealName,
        menuIndex,
        indexIngredientGropIndex,
        indexIngredient,
      }),
    );
    // console.log('addValue/currentActiveIngredient ==', currentActiveIngredient);
  };

  // Додає заберає товар з кошика
  const onChangeIsAddBasket = (props) => {
    dispatch(
      addDataToActiveingredientRedux({
        data: { ...activeIngredient, ifAddBasket: props },
        mealName,
        menuIndex,
        indexIngredientGropIndex,
        indexIngredient,
        ingredientsArray,
      }),
    );
  };

  return (
    <div className={styles.popup_fon}>
      <div className={styles.popup_content_wrapper}>
        <div className={styles.close_btn_wrapper}>
          <CloseBtn handleClick={closePopup} />
        </div>
        <NutritionalTableDay
          mealName={mealName}
          menuIndex={menuIndex}
          indexIngredientGropIndex={indexIngredientGropIndex}
          indexIngredient={indexIngredient}
        />

        {activeIngredient.textIngredientDefault ? (
          <div>
            <NutritionalValue activeIngredient={activeIngredient} mealName={mealName} />
            <div className={'mb_30'}>
              <div className={styles.final_text + ' ' + styles.final_text_menu}>
                <span className={'fz_10'}>⚫</span>
                {activeIngredient.text
                  ? activeIngredient.text
                  : activeIngredient.textIngredientDefault}
              </div>
              {activeIngredient.ifAddBasket && (
                <div className={styles.final_text + ' ' + styles.final_text_basket}>
                  <BasketSvg />
                  {activeIngredient.textBasketProduct
                    ? activeIngredient.textBasketProduct
                    : activeIngredient.textBasketProductNameDefault}
                </div>
              )}

              <div className="df aic gap_10 mt_30">
                <Checkbox
                  ifSelected={activeIngredient.ifAddBasket}
                  handleClick={onChangeIsAddBasket}
                />
                Додавати в кошик
              </div>
            </div>

            <div className={'mb_50 df gap_5'}>
              <button
                onClick={() =>
                  addValue(
                    'minus',
                    activeIngredient,
                    mealName,
                    menuIndex,
                    indexIngredientGropIndex,
                    indexIngredient,
                  )
                }
                className={styles.onChange_value_btn + ' ' + styles.onChange_value_btn_minus}>
                -
              </button>
              <input
                min="0"
                type="number"
                className={styles.input_value}
                value={activeIngredient.onChangeIngredientValue}
                onChange={(e) =>
                  addValue(
                    'targetValue',
                    activeIngredient,
                    mealName,
                    menuIndex,
                    indexIngredientGropIndex,
                    indexIngredient,
                    e.target.value.trim(),
                  )
                }
              />
              <button
                onClick={() =>
                  addValue(
                    'plus',
                    activeIngredient,
                    mealName,
                    menuIndex,
                    indexIngredientGropIndex,
                    indexIngredient,
                  )
                }
                className={styles.onChange_value_btn + ' ' + styles.onChange_value_btn_plus}>
                +
              </button>
            </div>

            <div className={'df jcsb '}>
              <button
                className={styles.cancel_btn}
                onClick={() =>
                  dispatch(
                    addDataToActiveingredientRedux({
                      data: getObjectIngredient(),
                      mealName,
                      menuIndex,
                      indexIngredientGropIndex,
                      indexIngredient,
                      ingredientsArray,
                    }),
                  )
                }>
                Очистити
              </button>
              <button onClick={() => closePopup(false)} className={styles.add_btn}>
                ОК
              </button>
            </div>
          </div>
        ) : (
          <>
            <input
              type="text"
              className={styles.input_search}
              placeholder="Пошук"
              defaultValue={search}
              onChange={(e) => searchIngredients(e.target.value.trimStart())}
            />

            <div className={styles.ingredients_list_wrapper}>
              {search ? (
                searchIngredientsArray.length ? (
                  renderIngredients(searchIngredientsArray)
                ) : (
                  <div>Збігу не знайдено :)</div>
                )
              ) : ingredientsArray.length ? (
                renderIngredients(ingredientsArray)
              ) : (
                <div>Пусто :)</div>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
